import React from 'react';

import { Card, FormItem, Toggle } from '../../../components';
import { Input } from '../../../components/Input';
import { useForm } from '../../../components/Form';
import type { AgentForm as AgentFormType } from '../../../utilities';

const VOICEMAIL_DEFAULTS = {
  voicemail_detection_max_listen_seconds: 20,
  voicemail_detection_max_utterances: 6,
} as const;

export type VoicemailDetectionSettingsProps = {
  disabled?: boolean;
  form: AgentFormType;
};

export const VoicemailDetectionSettings: React.FC<
  VoicemailDetectionSettingsProps
> = ({ disabled, form }) => {
  const { getValue, onChange } = useForm<AgentFormType>();

  const handleEnabledChange = (enabled: boolean) => {
    if (!enabled) {
      const current = getValue?.();
      if (current) {
        onChange?.({ ...current, ...VOICEMAIL_DEFAULTS });
      }
    }
  };

  return (
    <Card
      collapsable
      size="unset"
      title="VoiceMail keyword detection config"
      name="agentpage.voicemailDetection"
      contentClassName="flex flex-col gap-y-md"
      subtitle="Configure voicemail detection behavior during speech recognition"
      withOverflow={false}
    >
      <FormItem<AgentFormType>
        name="voicemail_detection_enabled"
        label="Enable"
        className="flex justify-between items-center"
      >
        <Toggle disabled={disabled} onChange={handleEnabledChange} />
      </FormItem>
      {form.voicemail_detection_enabled && (
        <>
          <FormItem<AgentFormType>
            name="voicemail_detection_max_listen_seconds"
            label="Max listen seconds"
          >
            <Input numeric disabled={disabled} />
          </FormItem>
          <FormItem<AgentFormType>
            name="voicemail_detection_max_utterances"
            label="Max utterances"
          >
            <Input numeric disabled={disabled} />
          </FormItem>
        </>
      )}
    </Card>
  );
};
